import Routes from 'components/Routes'
import { useFlags } from 'launchdarkly-react-client-sdk'
import MaintenancePage from 'components/Maintenance'

const App = () => {
  const { dpprMaintenancePage } = useFlags()

  return (
    <div className='App' data-testid='App'>
      {dpprMaintenancePage ? <MaintenancePage /> : <Routes />}
    </div>
  )
}

export default App
